import React, { useCallback } from 'react'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'
import MediaList from 'components/partials/MediaList'
import MediaContent from 'components/partials/MediaContent'
import IconArrowRight from 'components/partials/IconArrowRight'
import Description from 'components/partials/Description'
import Breadcrumb from 'components/Breadcrumb'
import { Link } from 'components/Link'
import ViewModeContext from 'contexts/ViewModeContext'
import useClickLogger from 'api/ClickLogger'

function EducationTemplate({ ...doc }) {
  const { t, i18n } = useTranslation()
  const mutateFields = {
    academic_credits(value) {
      value = Number(value).toFixed(value % 1 === 0 ? 0 : 1)
      value = i18n.language !== 'sv' ? value : value.replace(/\./, ',')
      value = `${value} ${t('suffix.academic_credits')}`
      return value
    }
  }

  Object.values(mutateFields).forEach((fieldFn) => {
    if (doc.hasOwnProperty(fieldFn.name))
      doc[fieldFn.name] = fieldFn(doc[fieldFn.name])
  })

  return (
    <ViewModeContext.Consumer>
      {context => context.isTable ? (
        <EducationTable {...doc} />
      ) : (
        <EducationTeaser {...doc} />
      )}
    </ViewModeContext.Consumer>
  )
}

export default EducationTemplate

function EducationTable({
  title,
  education_course_code,
  education_label,
  academic_credits,
  exchange_url,
  _click,
}) {
  const { trackResultClick } = useClickLogger(_click, exchange_url);
  return (
    <tr onClick={trackResultClick} style={{ cursor: 'pointer' }}>
      <td>
        <div className="media">
          <MediaContent>
            <Link href={exchange_url}>
              <span dangerouslySetInnerHTML={{ __html: title }} />
              <IconArrowRight />
            </Link>
          </MediaContent>
        </div>
      </td>
      <td>
        <Description text={education_course_code} />
      </td>
      <td>
        <Description text={education_label} />
      </td>
      <td>
        <Description text={academic_credits} />
      </td>
    </tr>
  )
}

const TableRow = styled.div`
  display: table-row;
`
const TableCell = styled.div`
  display: table-cell;
  padding-right: 16px;
`

function EducationTeaser({
  title,
  education_course_code,
  education_label,
  academic_credits,
  exchange_url,
  _click,
  __breadcrumb__,
}) {
  const { trackResultClick } = useClickLogger(_click, exchange_url);
  return (
    <MediaList onClick={trackResultClick}>
      <MediaContent>
        <Link href={exchange_url}>
          <span dangerouslySetInnerHTML={{ __html: title }} />
          <IconArrowRight />
        </Link>
        <div className="u-mt-25">
          <TableRow>
            <TableCell className="description u-text-color-secondary u-text-lowercase u-text-first-uppercase u-font-weight-700">
              {education_course_code}
            </TableCell>
            <TableCell className="description u-text-color-secondary u-text-lowercase u-text-first-uppercase u-font-weight-700">
              {education_label}
            </TableCell>
            <TableCell className="description u-text-color-secondary u-text-lowercase u-text-first-uppercase u-font-weight-700">
              {academic_credits}
            </TableCell>
          </TableRow>
        </div>
        <Breadcrumb links={__breadcrumb__} modifierClasses="u-mt-50" disabled />
      </MediaContent>
    </MediaList>
  )
}
